// extracted by mini-css-extract-plugin
export default {"root":"v8bA1B"};